import styled from 'styled-components';
import { device } from 'modules/Utils/Devices';

const Content = styled.main`
  position: relative;
  top: 0;
  width: 100%;
  min-width: 320px;
  min-height: calc(100vh - 80px);
  background-color: ${(props) => props.theme.config.colors.background};
  padding: 5.6rem 2.4rem
    ${(props) => (props.hasIdentifierEnv ? '11rem' : '7rem')}
    ${(props) => (props.sidebarExpanded ? '26.4rem' : '9.2rem')};
  transition: padding 0.2s ease-in;
  overflow: auto;

  @media ${device.tablet} {
    padding: 5.6rem 2.4rem 12rem
      ${(props) => (props.sidebarExpanded ? '25.8rem' : '9.2rem')};
  }

  @media ${device.mobile} {
    top: 0;
    padding: 3.2rem 1.6rem 12rem 1.6rem;
    min-height: calc(100vh - 60px);
  }
`;

export { Content };
